/* Customisable product page - Element Packaging, W-108, 27 October 2026. Used by sections/el-customiser.liquid.
   - Option pills and quantity tiles pick the variant; tiles show pack total, per unit and "save x%" against the
     smallest pack with the same other options. Prices are inc VAT in Shopify; ex VAT = inc / 1.2.
   - Markets (EU-40, 30 October 2026): D.market comes from the section's Liquid. Amounts follow Shopify's money
     format for the shopper's currency (D.market.money is a sample, 1234567.89, rendered by the money filter), and
     ex VAT is inc / 1.2 only where the market's prices include tax (UK). The EU market's prices are ex VAT, so
     they are shown as they are. Lead time and delivery line come per market too.
   - Choices are written to the URL (?material=...&quantity=...) and carried onto the sibling size links, and read
     back on load so adverts can deep-link a configured product.
   - Design routes: only the chosen route's fields are enabled, so the other routes' properties are not posted.
   - Add to basket posts the form as multipart to /cart/add.js (file uploads need it), then sets the cart attribute
     "Print order" so ops know the artwork is on the Shopify order (line properties do not reach Zoho).
   - Quote variants (price 0 or "Custom Quote") swap the basket button for the quote form. So does the theme-made
     quote tile (value __quote, no variant; W-115, 2 November 2026), and ?quantity=...quote... selects it. While a
     quote is chosen the form's variant id is emptied, so nothing can reach the basket from it.
   - "Design online" (hidden unless switched on) fires el:designer-open and opens the Element OS designer full
     screen over the page (Shopify customiser Phase B, 28 October 2026); the design comes back by postMessage and
     goes on the line as Design ref, _design_token and _preview_url. #el-design=<id>.<token> reopens it.
   - Reorder link (Shopify customiser Phase F, 28 October 2026): #el-reorder=<id>.<token>&ref=&img= puts the approved
     design on the line as it is (no designer, no new proof); "Change this design" copies it into a new draft.
   - Your reference (28 October 2026): the shopper's own name or SKU for the design comes back with it (and on a
     reorder link as &yref=) and goes on the line as the visible property "Your reference".
   - Logged in (28 October 2026): when the designer says el:designer-ready, the shopper's name and email (the quote
     form's fields, which Liquid fills from the customer account) go to it as el:shopper, to fill in "Email me a link".
   - Account image library (29 October 2026): opening the designer asks the app proxy /apps/element/shopper, which
     Shopify signs with the signed-in customer; its ticket goes in el:shopper too, so the designer keeps a signed-in
     shopper's images on their store account on any device. Signed out (or the proxy unreachable), no ticket.
   - Quantity rows: price per unit in bold, pack total under it; rows past the first few fold behind
     "Show all quantities". The lead time line follows the quantity (standard vs volume production). */
(function () {
  var root = document.querySelector('[data-el-cz]');
  if (!root) return;
  var dataEl = document.querySelector('[data-el-cz-data]');
  if (!dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var form = root.querySelector('[data-el-cz-form]');
  var idInput = root.querySelector('[data-el-cz-id]');
  var addBtn = root.querySelector('[data-el-cz-add]');
  var quoteBtn = root.querySelector('[data-el-cz-quote-btn]');
  var quote = root.querySelector('[data-el-cz-quote]');
  var errEl = root.querySelector('[data-el-cz-error]');
  var bar = root.querySelector('[data-el-cz-bar]');
  var barBtn = root.querySelector('[data-el-cz-bar-btn]');
  var summary = root.querySelector('[data-el-cz-summary]');

  function $$(s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); }
  var MK = D.market || {};
  // EU-42: words from the section (theme locale files, keys el.cz_js.*); English when a key is missing
  var TT = D.t || {};
  function tr(k, en, v) {
    var str = typeof TT[k] === 'string' && TT[k] && TT[k].indexOf('translation missing') < 0 ? TT[k] : en;
    return str.replace(/\{(\w+)\}/g, function (m, n) { return v && v[n] !== undefined ? v[n] : m; });
  }
  var taxInc = MK.taxInc !== false;
  // Split the money sample into prefix, suffix and separators: "£1,234,567.89", "€1.234.567,89", "1 234 567,89 kr"
  var M = (function (s) {
    s = String(s || '£1,234,567.89').replace(/\s+/g, ' ').trim();
    var a = s.search(/\d/), b = s.length - 1;
    while (b > a && !/\d/.test(s.charAt(b))) b--;
    var n = s.slice(a, b + 1);
    var dec = /[.,]\d{2}$/.test(n) ? n.charAt(n.length - 3) : '';
    var th = n.slice(0, dec ? -3 : n.length).replace(/\d/g, '').charAt(0);
    return { pre: s.slice(0, a), suf: s.slice(b + 1), dec: dec, th: th };
  })(MK.money);
  function num(x, d) {
    var parts = x.toFixed(d).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, M.th) + (d ? (M.dec || '.') + parts[1] : '');
  }
  function fmt(p) { return M.pre + num(p / 100, M.dec ? 2 : 0) + M.suf; }
  function exv(p) { return taxInc ? Math.round(p / 1.2) : p; }
  function perUnit(ex, u) {
    if (!u) return '';
    var tenths = Math.floor(ex * 10 / u);
    if (tenths < 1000) return M.pre + '0' + (M.dec || '.') + ('00' + tenths).slice(-3) + M.suf;
    return M.pre + num(ex / u / 100, 2) + M.suf;
  }
  function handleize(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  var sel = [];
  var showAll = false;
  var moreBtn = root.querySelector('[data-el-cz-qmore]');
  if (moreBtn) moreBtn.addEventListener('click', function () { showAll = true; moreBtn.remove(); renderTiles(); });
  function isVolume(v) { return !!v && (v.q || (v.u > 0 && v.u >= (D.volumeFrom || 50000))); }
  function readSel() {
    D.options.forEach(function (o, i) {
      var c = root.querySelector('input[data-el-cz-opt="' + i + '"]:checked');
      sel[i] = c ? c.value : (o.values.length === 1 ? o.values[0] : sel[i]);
    });
  }
  function find(opts) {
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) { if (v.o[j] !== opts[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function current() { return find(sel); }

  // Read ?material=...&quantity=... (option names handleized) and ?variant=
  (function fromUrl() {
    var q = new URLSearchParams(location.search);
    var changed = false;
    D.options.forEach(function (o, i) {
      var want = q.get(o.key);
      if (!want) return;
      want = handleize(want);
      o.values.forEach(function (val) {
        if (handleize(val) === want) {
          var inp = root.querySelector('input[data-el-cz-opt="' + i + '"][value="' + CSS.escape(val) + '"]');
          if (inp) { inp.checked = true; changed = true; }
        }
      });
      // Old links to the deleted "50k+ (Custom Quote)" variants land on the theme-made quote tile
      if (i === D.qPos && want.indexOf('quote') >= 0) {
        var qt = root.querySelector('input[data-el-cz-opt="' + i + '"][value="__quote"]');
        if (qt) { qt.checked = true; changed = true; }
      }
    });
    return changed;
  })();

  function renderTiles() {
    if (D.qPos < 0) return;
    var base = null;
    D.variants.forEach(function (v) {
      var same = v.o.every(function (x, j) { return j === D.qPos || x === sel[j]; });
      if (same && !v.q && v.u > 0 && (!base || v.u < base.u)) base = v;
    });
    var baseUnit = base ? exv(base.p) / base.u : 0;
    $$('[data-el-cz-tile]').forEach(function (tile) {
      var opts = sel.slice(); opts[D.qPos] = tile.getAttribute('data-el-cz-tile');
      var v = tile.hasAttribute('data-el-cz-qtile') ? { q: true } : find(opts);
      var tot = tile.querySelector('[data-el-cz-t-total]');
      var unit = tile.querySelector('[data-el-cz-t-unit]');
      var save = tile.querySelector('[data-el-cz-t-save]');
      var per = tile.querySelector('[data-el-cz-t-per]');
      tile.classList.toggle('is-quote', !!(v && v.q));
      // Rows past the first few stay folded until "Show all quantities", unless selected
      var input = tile.querySelector('input');
      tile.hidden = !v || (tile.classList.contains('is-more') && !showAll && !(input && input.checked));
      if (!v) return;
      if (v.q) {
        setText(unit, tr('get_quote', 'Get a quote')); if (per) per.hidden = true; setText(tot, tr('priced_to_order', 'Priced to order')); save.hidden = true; return;
      }
      var ex = exv(v.p);
      if (per) per.hidden = false;
      setText(unit, perUnit(ex, v.u));
      setText(tot, tr('total_amount', '{amount} total', { amount: fmt(ex) }));
      var pct = baseUnit ? Math.floor((1 - (ex / v.u) / baseUnit) * 100) : 0;
      if (pct >= 1) { setText(save, tr('save_pct', 'Save {pct}%', { pct: pct })); save.hidden = false; } else { save.hidden = true; }
    });
  }

  function writeUrl() {
    var q = new URLSearchParams(location.search);
    D.options.forEach(function (o, i) { if (o.values.length > 1 && sel[i]) q.set(o.key, handleize(sel[i])); });
    var v = current();
    if (v) q.set('variant', v.id); else q.delete('variant');
    history.replaceState(null, '', location.pathname + '?' + q.toString() + location.hash);
    // Carry the choices onto sibling links (not variant ids, which differ per product)
    var carry = new URLSearchParams();
    D.options.forEach(function (o, i) { if (o.values.length > 1 && sel[i]) carry.set(o.key, handleize(sel[i])); });
    $$('[data-el-cz-sib]').forEach(function (a) {
      var base = a.getAttribute('href').split('?')[0];
      var keep = new URLSearchParams(a.search);
      if (keep.has('preview_theme_id') || q.has('preview_theme_id')) carry.set('preview_theme_id', q.get('preview_theme_id') || keep.get('preview_theme_id'));
      a.setAttribute('href', base + '?' + carry.toString());
    });
  }

  function render() {
    readSel();
    var v = current();
    renderTiles();
    var total = root.querySelector('[data-el-cz-total]');
    var inc = root.querySelector('[data-el-cz-inc]');
    var unit = root.querySelector('[data-el-cz-unit]');
    var barTotal = root.querySelector('[data-el-cz-bar-total]');
    var isQuote = !v || v.q;
    idInput.value = isQuote ? '' : v.id;
    if (isQuote) {
      setText(total, tr('priced_to_order', 'Priced to order')); if (inc) setText(inc, '-'); setText(unit, tr('tell_us', 'tell us what you need'));
      setText(barTotal, tr('priced_to_order', 'Priced to order'));
    } else {
      var ex = exv(v.p);
      setText(total, fmt(ex)); if (inc) setText(inc, fmt(v.p));
      setText(unit, tr('each', '{price} each', { price: perUnit(ex, v.u) }));
      setText(barTotal, fmt(ex));
    }
    // Lead time: standard below D.volumeFrom pieces, volume production from it (and on quote)
    var vol = isVolume(v) || !v;
    var delivery = MK.delivery === undefined ? 'Free UK delivery.' : MK.delivery;
    setText(root.querySelector('[data-el-cz-lead]'), (vol
      ? tr('lead_volume', 'Volume production, {lead} after proof approval.', { lead: D.leadVolume })
      : tr('lead_standard', 'About {lead} after proof approval.', { lead: D.leadStandard })) + ' ' + delivery);
    setText(root.querySelector('[data-el-cz-bar-lead]'), vol ? tr('delivered_in', 'Delivered in {lead}', { lead: D.leadVolume }) : tr('delivered_in_about', 'Delivered in about {lead}', { lead: D.leadStandard }));
    addBtn.hidden = isQuote;
    quoteBtn.hidden = !isQuote;
    setText(barBtn, isQuote ? tr('request_quote', 'Request a quote') : tr('add_to_basket', 'Add to basket'));
    if (!isQuote && quote && !quote.querySelector('[data-el-cz-quote-sent]')) quote.hidden = true;
    if (v && !v.a && !v.q) { addBtn.disabled = true; setText(addBtn, tr('unavailable', 'Unavailable')); }
    else if (!addBtn.classList.contains('is-busy')) { addBtn.disabled = false; setText(addBtn, tr('add_to_basket', 'Add to basket')); }
    var qo = root.querySelector('[data-el-cz-quote-opts]');
    if (qo) qo.value = D.options.map(function (o, i) { return o.name + ': ' + (sel[i] || ''); }).join(', ');
    writeUrl();
  }

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-el-cz-opt]')) { showError(''); render(); }
    if (t.matches('[data-el-cz-route]')) { showError(''); pickRoute(t.value); }
    if (t.matches('[data-el-cz-file]')) {
      var f = t.files && t.files[0];
      if (f && f.size > D.maxBytes) { t.value = ''; showError(tr('err_file_big', 'That file is over 20 MB. Please send a smaller file, or choose "Design later" and we will collect it by email.')); }
    }
  });

  function pickRoute(route) {
    $$('[data-el-cz-body]').forEach(function (b) {
      var on = b.getAttribute('data-el-cz-body') === route;
      b.hidden = !on;
      $$('input, textarea, select', b).forEach(function (f) { f.disabled = !on; });
    });
  }

  // Gallery
  $$('[data-el-cz-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var img = root.querySelector('[data-el-cz-main] img');
      if (!img) return;
      img.removeAttribute('srcset');
      img.src = b.getAttribute('data-src');
      img.alt = b.getAttribute('data-alt') || '';
      $$('[data-el-cz-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
    });
  });

  function showError(msg) {
    if (!msg) { errEl.hidden = true; errEl.textContent = ''; return; }
    errEl.textContent = msg; errEl.hidden = false;
  }

  function openQuote() {
    if (!quote) return;
    quote.hidden = false;
    quote.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var f = quote.querySelector('input[name="contact[name]"]');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 400);
  }
  quoteBtn.addEventListener('click', openQuote);
  if (quote && quote.querySelector('[data-el-cz-quote-sent], .el-cz__error')) quote.hidden = false;

  function validate() {
    var r = root.querySelector('[data-el-cz-route]:checked');
    if (!r) return tr('err_route', 'Choose how you would like to send your design.');
    if (r.value === 'Upload') {
      var f = root.querySelector('[data-el-cz-body="Upload"] [data-el-cz-file]');
      if (!f.files || !f.files[0]) return tr('err_artwork', 'Add your artwork file, or choose "Design later".');
      if (f.files[0].size > D.maxBytes) return tr('err_file_big_short', 'That file is over 20 MB. Please send a smaller file.');
    }
    if (r.value === 'Design help') {
      var b = root.querySelector('[data-el-cz-brief]');
      if (!b.value.trim()) return tr('err_brief', 'Tell us briefly what you would like printed.');
      var lf = root.querySelector('[data-el-cz-body="Design help"] [data-el-cz-file]');
      if (lf.files && lf.files[0] && lf.files[0].size > D.maxBytes) return tr('err_file_big_short', 'That file is over 20 MB. Please send a smaller file.');
    }
    if (r.value === 'Design online') {
      var tk = root.querySelector('[data-el-cz-dfield="token"]');
      if (!tk || !tk.value) return tr('err_design_first', 'Design your cup first, or choose another way to send your design.');
    }
    return '';
  }

  function setCount(n) {
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      el.setAttribute('data-header-cart-count', n > 0 ? String(n) : '');
      el.classList.toggle('visible', n > 0);
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = current();
    if (!v || v.q) { openQuote(); return; }
    var msg = validate();
    if (msg) {
      showError(msg);
      var d = root.querySelector('[data-el-cz-design]');
      if (d) d.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    showError('');
    var fd = new FormData(form);
    fd.set('id', v.id);
    fd.set('quantity', '1');
    // An empty optional file input would post a blank file; drop empty fields
    var clean = new FormData();
    fd.forEach(function (val, key) {
      if (val instanceof File) { if (val.size > 0) clean.append(key, val); }
      else if (String(val).trim() !== '') clean.append(key, val);
    });
    addBtn.disabled = true; addBtn.classList.add('is-busy'); setText(addBtn, tr('adding', 'Adding...'));
    fetch('/cart/add.js', { method: 'POST', body: clean, credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (r.status === 413) throw { description: tr('err_too_large', 'That file is too large to upload. Please send a file under 20 MB.') };
        return r.json().then(function (d) { if (!r.ok) throw d; return d; });
      })
      .then(function () {
        var attrs = {}; attrs['Print order'] = D.printOrderAttr || 'Yes';
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).then(function (r) { return r.json(); }).catch(function () { return null; });
      })
      .then(function (cart) {
        if (cart && cart.item_count) setCount(cart.item_count);
        window.location.href = '/cart';
      })
      .catch(function (err) {
        showError((err && (err.description || err.message)) || tr('err_add', 'Sorry, that could not be added. Please try again.'));
        addBtn.disabled = false; addBtn.classList.remove('is-busy'); setText(addBtn, tr('add_to_basket', 'Add to basket'));
      });
  });

  // Phone bar: shows once the summary has scrolled out of view
  if (bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (ents) {
      var on = !ents[0].isIntersecting;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      barBtn.tabIndex = on ? 0 : -1;
    }).observe(summary);
  }
  barBtn.addEventListener('click', function () {
    var v = current();
    if (!v || v.q) { openQuote(); return; }
    if (!root.querySelector('[data-el-cz-route]:checked')) {
      var d = root.querySelector('[data-el-cz-design]');
      if (d) d.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
  });

  // Design online (Shopify customiser Phase B, 28 October 2026) - hidden unless settings.designer_enabled and
  // element.print_variant_id are both set. Opens the Element OS designer full screen over this page (a <dialog>
  // holding an iframe; the shopper never leaves myelement.co.uk). The designer posts back to this origin only:
  // el:design-saved {designRef, token, previewUrl} adds this pack to the basket with the design on the line
  // (Design route = Design online, Design ref, _design_token, _preview_url); el:designer-close closes it.
  // An emailed link lands here with #el-design=<id>.<token> and reopens the designer on that design.
  var des = root.querySelector('[data-el-cz-designer]');
  if (des) {
    var dUrl = des.getAttribute('data-url') || '';
    var dOrigin = '';
    try { dOrigin = new URL(dUrl).origin; } catch (e) { dOrigin = ''; }
    var block = des.closest('.el-cz__route--online');
    // The headline route: the brand yellow of the other primary buttons, not the ghost style (Adam 28 Oct 2026)
    des.classList.remove('el-cz__btn--ghost');
    var css = document.createElement('style');
    css.textContent = '.el-cz-lock,.el-cz-lock body{overflow:hidden}'
      + '.el-cz__dlg{position:fixed;inset:0;width:100vw;height:100vh;height:100dvh;max-width:none;max-height:none;margin:0;padding:0;border:0;background:#fff}'
      + '.el-cz__dlg::backdrop{background:rgba(20,20,20,.55)}'
      + '.el-cz__dlg iframe{display:block;width:100%;height:100%;border:0}'
      + '@media (min-width:990px){.el-cz__dlg{inset:0;width:min(1400px,96vw);height:92vh;margin:auto;border-radius:16px;overflow:hidden}}'
      + '.el-cz__dthumb{display:flex;align-items:center;gap:12px;margin-top:8px}'
      + '.el-cz__dthumb img{width:72px;height:72px;object-fit:cover;border-radius:10px;background:#f4f4f4}'
      + '.el-cz__dthumb p{margin:0;font-size:13px;line-height:1.4}';
    document.head.appendChild(css);

    // The route radio and its fields, so pickRoute / validate / the form treat it like the other routes
    var radio = document.createElement('input');
    radio.type = 'radio'; radio.name = 'properties[Design route]'; radio.value = 'Design online';
    radio.setAttribute('data-el-cz-route', ''); radio.hidden = true; radio.tabIndex = -1;
    if (block) block.appendChild(radio);
    var body = document.createElement('div');
    body.className = 'el-cz__route-body'; body.setAttribute('data-el-cz-body', 'Design online'); body.hidden = true;
    body.innerHTML = '<div class="el-cz__dthumb" data-el-cz-dthumb hidden><img alt=""><p><b></b><br><span data-el-cz-dref></span></p></div>'
      + '<input type="hidden" name="properties[Design ref]" data-el-cz-dfield="ref" disabled>'
      + '<input type="hidden" name="properties[_design_token]" data-el-cz-dfield="token" disabled>'
      + '<input type="hidden" name="properties[_preview_url]" data-el-cz-dfield="preview" disabled>'
      + '<input type="hidden" name="properties[Your reference]" data-el-cz-dfield="yref" disabled>';
    if (block && block.parentNode) block.parentNode.insertBefore(body, block.nextSibling);
    body.querySelector('[data-el-cz-dthumb] img').alt = tr('your_cup_design', 'Your cup design');
    setText(body.querySelector('[data-el-cz-dthumb] b'), tr('design_ready', 'Your design is ready'));
    function dfield(k) { return body.querySelector('[data-el-cz-dfield="' + k + '"]'); }

    var dlg = document.createElement('dialog');
    dlg.className = 'el-cz__dlg';
    dlg.setAttribute('aria-label', tr('design_your', 'Design your {product}', { product: (document.querySelector('.el-cz__title') || {}).textContent }));
    var frame = document.createElement('iframe');
    frame.title = tr('frame_title', 'Design online');
    frame.setAttribute('allow', 'clipboard-write');
    dlg.appendChild(frame);
    document.body.appendChild(dlg);

    // A reorder link's design (<id>.<token>) until the shopper changes it; cloned once it has been copied
    var reorderLink = null, cloned = false;

    // The signed-in shopper's ticket from the app proxy, fetched each time the designer opens (it lasts an hour)
    var ticketReq = null;
    function fetchTicket() {
      ticketReq = fetch('/apps/element/shopper', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return j && j.signedIn && typeof j.ticket === 'string' ? j.ticket : ''; })
        .catch(function () { return ''; });
      return ticketReq;
    }

    function designerSrc(resume, clone) {
      var v = current();
      var u = new URL(dUrl, location.origin);
      u.searchParams.set('print_variant', des.getAttribute('data-print-variant') || '');
      if (v) {
        u.searchParams.set('shopify_variant', v.id);
        if (!v.q) { u.searchParams.set('price_ex', exv(v.p)); if (v.u) u.searchParams.set('units', v.u); }
      }
      u.searchParams.set('lead', isVolume(v) ? D.leadVolume : tr('about_lead', 'about {lead}', { lead: D.leadStandard }));
      // Market (EU-40/50): the country drives the EU single-use plastic mark (PR #830), the currency the designer's
      // price label; price_ex above is already ex VAT in that currency.
      if (MK.country) u.searchParams.set('country', MK.country);
      if (MK.currency) u.searchParams.set('currency', MK.currency);
      u.searchParams.set('parent', location.origin);
      var back = new URL(location.href); back.hash = '';
      u.searchParams.set('return', back.toString());
      // MKT-01 measurement (W-112): the first landing page's campaign parameters (snippets/el-first-touch.liquid)
      // and our test flag (?el_test=1, the demo recorder), saved on a new design by Element OS
      var ft = window.ElFirstTouch && window.ElFirstTouch.param();
      if (ft) u.searchParams.set('ft', ft);
      if (/[?&]el_test=1(&|$)/.test(location.search)) u.searchParams.set('el_test', '1');
      if (clone) u.hash = 'clone=' + clone; else if (resume) u.hash = 'resume=' + resume;
      return u.toString();
    }
    function openDesigner(resume, clone) {
      var v = current();
      var detail = { productVariantId: v ? v.id : null, printVariantId: des.getAttribute('data-print-variant'), options: sel.slice() };
      if (!document.dispatchEvent(new CustomEvent('el:designer-open', { detail: detail, cancelable: true }))) return;
      if (!dUrl || !dOrigin) return;
      fetchTicket();
      frame.src = designerSrc(resume, clone);
      document.documentElement.classList.add('el-cz-lock');
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    }
    function closeDesigner() {
      if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
      document.documentElement.classList.remove('el-cz-lock');
      frame.src = 'about:blank';
    }
    // Escape closes it (the design autosaves)
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeDesigner(); });

    function setDesign(m, label) {
      radio.checked = true;
      pickRoute('Design online');
      dfield('ref').value = m.designRef || '';
      dfield('token').value = m.token || '';
      dfield('preview').value = m.previewUrl || '';
      var yref = typeof m.reference === 'string' ? m.reference.trim().slice(0, 80) : '';
      dfield('yref').value = yref;
      var th = body.querySelector('[data-el-cz-dthumb]');
      setText(body.querySelector('[data-el-cz-dref]'), (yref ? yref + ', ' : '') + (m.designRef ? tr('design_ref', 'Design {ref}', { ref: m.designRef }) : ''));
      if (m.previewUrl) { th.querySelector('img').src = m.previewUrl; }
      setText(th.querySelector('b'), label || tr('design_ready', 'Your design is ready'));
      th.hidden = false;
      setText(des, tr('edit_design', 'Edit design'));
    }

    des.addEventListener('click', function () {
      // a reorder is never edited in place: the first click copies it into a new draft, later clicks reopen the copy
      if (reorderLink && !cloned) { cloned = true; openDesigner(null, reorderLink); return; }
      openDesigner(null);
    });
    window.addEventListener('message', function (e) {
      if (!dOrigin || e.origin !== dOrigin || !e.data || typeof e.data.type !== 'string') return;
      if (e.data.type === 'el:designer-close') { closeDesigner(); return; }
      if (e.data.type === 'el:designer-ready') {
        var qe = root.querySelector('#el-cz-quote-form input[name="contact[email]"]');
        var qn = root.querySelector('#el-cz-quote-form input[name="contact[name]"]');
        var email = qe ? qe.defaultValue.trim() : '';
        var name = qn ? qn.defaultValue.trim() : '';
        (ticketReq || Promise.resolve('')).then(function (ticket) {
          if (!(email || ticket) || !frame.contentWindow) return;
          var msg = { type: 'el:shopper', email: email, name: name, company: '' };
          if (ticket) msg.ticket = ticket;
          frame.contentWindow.postMessage(msg, dOrigin);
        });
        return;
      }
      if (e.data.type === 'el:design-saved' && typeof e.data.token === 'string') {
        reorderLink = null;
        setDesign(e.data);
        closeDesigner();
        showError('');
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      }
    });

    // An emailed link: #el-design=<design id>.<token> (opened after render() has read the chosen options)
    var m = /^#el-design=([0-9a-f-]{36}\.[A-Za-z0-9_-]{43})$/.exec(location.hash);
    if (m) {
      history.replaceState(null, '', location.pathname + location.search);
      setTimeout(function () { openDesigner(m[1]); }, 0);
    }

    // A reorder link: the approved design goes on the line as it is. The render must come from our guest-previews folder.
    var rq = new URLSearchParams(location.hash.slice(1));
    var ro = rq.get('el-reorder') || '';
    if (/^[0-9a-f-]{36}\.[A-Za-z0-9_-]{43}$/.test(ro)) {
      history.replaceState(null, '', location.pathname + location.search);
      var rimg = rq.get('img') || '';
      if (rimg.indexOf('https://qqncywavwlhofqcdjaxl.supabase.co/storage/v1/object/public/design-files/guest-previews/') !== 0) rimg = '';
      var rref = /^D-[A-Z0-9]{4,8}$/.test(rq.get('ref') || '') ? rq.get('ref') : '';
      reorderLink = ro;
      setDesign({ designRef: rref, token: ro.split('.')[1], previewUrl: rimg, reference: rq.get('yref') || '' }, tr('reordering', 'Reordering your approved design, no new proof needed'));
      setText(des, tr('change_design', 'Change this design'));
      var dblock = root.querySelector('[data-el-cz-design]');
      if (dblock) setTimeout(function () { dblock.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
    }
  }

  render();
})();
